const CLEAR_WARNING =
  "[SessionManager] Failed to access storage while clearing client state:";

/**
 * Removes all application data stored in localStorage and sessionStorage.
 * This is invoked on logout, auto logout, and right before establishing a
 * brand-new session to guarantee that a new user never inherits leftovers
 * from the previous account.
 */
export const clearClientStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.warn(CLEAR_WARNING, error?.message || error);
  }

  try {
    sessionStorage.clear();
  } catch (error) {
    console.warn(CLEAR_WARNING, error?.message || error);
  }
};

export const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
export const ACTIVITY_EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart", "wheel"];

